import Vue from "vue";
import router from "./router/router";
import accounting from "accounting";
import pluralize from "pluralize";
import App from "./App";
import layout from "./components/shared/layout.vue";
import FullLayout from "./components/shared/FullLayout.vue";
import mobileLayout from "./components/shared/mobileLayout.vue";
import VeeValidate from "vee-validate";
import BlockUI from "vue-blockui";
import { veeCustomMessage } from "./helpers/validation/dictionary";
import { DetectMobile } from "./helpers/ui/detectmobile";
import { formatCard } from "./helpers/filters/formatCard";
import { camelCase } from "./helpers/filters/camelCase";
import VueMask from "v-mask";
import EventBus from "./event-bus";
import { StripePlugin } from '@vue-stripe/vue-stripe';
import {AppConfig} from "../AppConfig";

Vue.use(BlockUI);
Vue.mixin(DetectMobile);
Vue.use(VeeValidate, {
  dictionary: veeCustomMessage,
  errorBagName: "OOErrors"
});

Vue.use(StripePlugin, {
  // Todo handle sandbox and live keys
  pk: AppConfig.stripeToken
})

Vue.use(VueMask);
Vue.component("default-layout", layout);
Vue.component("full-layout", FullLayout);
Vue.component("mobile-layout", mobileLayout);

require("./assets/bootstrap/scss/bootstrap.scss");

require("./assets/main.scss");
require("jquery/dist/jquery.slim");
require("popper.js");
require("bootstrap");
Vue.config.productionTip = false;

Vue.filter("formatMoney", accounting.formatMoney);
Vue.filter("pluralize", pluralize);
Vue.filter("formatCard", formatCard);
Vue.filter("camelCase", camelCase);
new Vue({
  el: "#shop",
  router: router,
  mounted() {
    EventBus.$on('update-stripe-config', stripeKey => {
      Vue.use(StripePlugin, {
        pk: stripeKey
      });
    });
  },
  render: h => h(App)
});

